import React, { useState } from "react";
import "./AddressSelection.css";

function AddressSelection({ onBack, onContinue }) {
  const [selectedDoc, setSelectedDoc] = useState("utility-bill");

  const handleContinue = () => {
    onContinue(selectedDoc);
  };

  return (
    <div className="address-selection-container">
      <div className="address-selection-card">
        <div className="address-selection-header">
          <button className="back-button" onClick={onBack}>
            ←
          </button>
          <div className="header-progress">
            <div
              className="header-progress-fill"
              style={{ width: "80%" }}
            ></div>
          </div>
        </div>

        <div>
          <h2 className="address-selection-title">Proof of Address</h2>
          <p className="address-selection-subtitle">
            Please select the type of document you want to upload
          </p>

          <div className="address-selection-options">
            <label
              className={`address-selection-option ${selectedDoc === "utility-bill" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" />
                  <polyline points="13 2 13 9 20 9" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
                <span className="option-label">Utility Bill</span>
              </div>
              <input
                type="radio"
                name="address-doc"
                value="utility-bill"
                checked={selectedDoc === "utility-bill"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>

            <label
              className={`address-selection-option ${selectedDoc === "bank-statement" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="12" y1="1" x2="12" y2="23" />
                  <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
                </svg>
                <span className="option-label">Bank Statement</span>
              </div>
              <input
                type="radio"
                name="address-doc"
                value="bank-statement"
                checked={selectedDoc === "bank-statement"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>

            <label
              className={`address-selection-option ${selectedDoc === "govt-letter" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
                <span className="option-label">Government Issued Document</span>
              </div>
              <input
                type="radio"
                name="address-doc"
                value="govt-letter"
                checked={selectedDoc === "govt-letter"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>
          </div>

          <div className="privacy-notice">
            <svg
              className="lock-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="5" y="11" width="14" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 018 0v4" />
            </svg>
            <span>Your document is handled securely and privately.</span>
          </div>
        </div>

        <div>
          <button className="continue-button" onClick={handleContinue}>
            Next
          </button>
          <div className="address-selection-footer">Secured by VerifiLite</div>
        </div>
      </div>
    </div>
  );
}

export default AddressSelection;
